import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './PaymentStatusPage.css';
import PageTransition from '../components/PageTransition';

const PaymentStatusPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const isSuccess = searchParams.get('success') === 'true';
    const type = searchParams.get('type');

    // In a real implementation with POST redirect, the data would typically 
    // be handled by a backend endpoint which redirects here with query params, 
    // or we'd need to parse the form data (if possible in client-side router).
    // For this Sandbox flow, we'll assume a basic success landing.

    return (
        <main className="flex-grow payment-status-container bg-background-light dark:bg-background-dark">
            <div className="payment-status-card">
                <div className="status-icon-wrapper">
                    <div className={`status-icon-circle ${!isSuccess ? 'error' : ''}`}>
                        {/* Using volunteer_activism as it represents 'safe hands' / giving well */}
                        <span className={`material-symbols-outlined status-icon ${!isSuccess ? 'error' : ''}`}>
                            {isSuccess ? 'volunteer_activism' : 'error'}
                        </span>
                    </div>
                </div>

                <h1 className="status-title">
                    {isSuccess
                        ? (type === 'service' ? 'Your Dharisanam will be done by Us' : 'Your Donation is in Safe Hands')
                        : 'Payment Failed'}
                </h1>

                <div className={`h-1 w-16 mx-auto rounded-full mb-6 ${isSuccess ? 'bg-primary' : 'bg-red-500'}`}></div>

                <p className="status-message">
                    {isSuccess ? (
                        <>
                            {type === 'service' ? (
                                <>
                                    Have a great day.<br />
                                    Thank you for your booking. May the divine blessings be with you and your family.
                                </>
                            ) : (
                                <>
                                    We received your payment.<br />
                                    Thank you for your generous contribution. May the divine blessings be with you and your family.
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            Unfortunately, your payment could not be processed.<br />
                            {type === 'service' ? 'Please try again.' : 'Please try again or contact support if the issue persists.'}
                        </>
                    )}
                </p>

                {isSuccess ? (
                    <button
                        onClick={() => navigate('/')}
                        className="home-button"
                    >
                        <span className="material-symbols-outlined">home</span>
                        Return to Home
                    </button>
                ) : (
                    <div className="flex flex-col gap-3 w-full items-center">
                        <button
                            onClick={() => navigate('/donations')}
                            className="home-button"
                            style={{ backgroundColor: '#ef4444', color: 'white', boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)' }}
                        >
                            <span className="material-symbols-outlined">refresh</span>
                            Try Again
                        </button>
                        <button
                            onClick={() => navigate('/')}
                            className="text-sm text-gray-500 hover:text-gray-700 underline mt-2"
                        >
                            Return to Home
                        </button>
                    </div>
                )}
            </div>
        </main>
    );
};

export default PageTransition(PaymentStatusPage);
